import { useContext } from 'react';

import AdvancedSearchContext from './AdvancedSearchContext';

const useAdvancedSearchContext = () => {
  const advancedSearchData = useContext(AdvancedSearchContext);
  return advancedSearchData;
};

export default useAdvancedSearchContext;
